module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJhbmRyb2lkLWNocm9tZS0xOTJ4MTkyLnBuZyI7"